"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Parser = _interopRequireDefault(require("@/components/FormGenerator/components/parser/Parser"));
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
var systemFormConfigApi = _interopRequireWildcard(require("@/api/systemFormConfig.js"));
var systemConfigApi = _interopRequireWildcard(require("@/api/systemConfig.js"));
var _index = _interopRequireDefault(require("@/views/application/wxAccount/wxTemplate/index"));
var _utils = require("@/components/FormGenerator/utils");
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
var _settings = require("@/config/settings");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  // name: "index",
  components: {
    Template: _index.default,
    parser: _Parser.default
  },
  data: function data() {
    return {
      loading: false,
      formConf: {
        content: {
          fields: []
        },
        id: null,
        render: false,
        isEdit: false
      },
      formConfChild: {
        content: {
          fields: []
        },
        id: null,
        render: false,
        isEdit: false
      },
      activeNamel1: null,
      activeNamel2: '',
      //针对文件特殊处理
      treeList: [],
      editDataChild: {},
      isCreate: 0,
      currentEditId: null,
      currentEditData: null
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:category:list'])) this.handlerGetTreeList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleTabClick: function handleTabClick(tab) {
      this.formConfChild.render = false;
      if (tab.$children.length && tab.$children[0].panes) {
        this.activeNamel2 = tab.$children[0].panes[0].name;
      } else {
        this.getFromId();
      }
      if (this.activeNamel2) this.handlerGetLevel2FormConfig(this.activeNamel2);
    },
    getFromId: function getFromId() {
      var _this = this;
      this.activeNamel2 = this.treeList.find(function (item) {
        return item.name == _this.activeNamel1;
      }).extra;
    },
    handlerGetLevel1FormConfig: function handlerGetLevel1FormConfig(id) {
      var _this2 = this;
      var formPram = {
        id: id
      };
      this.currentEditId = id;
      this.formConf.content = {
        fields: []
      };
      this.formConf.render = false;
      this.loading = true;
      systemFormConfigApi.getFormConfigInfo(formPram).then(function (data) {
        var id = data.id,
          name = data.name,
          info = data.info,
          content = data.content;
        _this2.formConf.content = JSON.parse(content);
        _this2.formConf.id = id;
        _this2.handlerGetSettingInfo(id, 1);
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    handleItemTabClick: function handleItemTabClick(tab, event) {
      //这里对tabs=tab.name和radio=id做了兼容
      var _id = tab.name ? tab.name : tab;
      if (!_id) return this.$message.error('表单配置不正确，请关联正确表单后使用');
      this.handlerGetLevel2FormConfig(_id);
    },
    handlerGetLevel2FormConfig: function handlerGetLevel2FormConfig(id) {
      var _this3 = this;
      var formPram = {
        name: id
      };
      this.currentEditId = id;
      this.formConfChild.content = {
        fields: []
      };
      this.formConfChild.render = false;
      this.loading = true;
      systemFormConfigApi.formTempNameInfoApi(formPram).then(function (data) {
        var id = data.id,
          name = data.name,
          info = data.info,
          content = data.content;
        _this3.formConfChild.content = JSON.parse(content);
        _this3.formConfChild.id = id;
        _this3.handlerGetSettingInfo(id, 2);
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    // 表单详情
    handlerGetSettingInfo: function handlerGetSettingInfo(id, level) {
      var _this4 = this;
      this.formConf.id = id;
      systemConfigApi.configInfo({
        id: id
      }).then(function (data) {
        //小程序登录配置，此处返回字符串，表单组件是数组，需要字符串转为数组
        if (data.routine_phone_verification) data.routine_phone_verification = data.routine_phone_verification.split(',').map(Number);
        _this4.currentEditData = data;
        _this4.formConfChild.isEdit = _this4.currentEditData !== null;
        _this4.formConfChild.render = true;
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (formValue) {
      if ((0, _permission.checkPermi)(['platform:system:config:save:form'])) {
        this.handlerSave(formValue);
      } else {
        this.$message.warning('暂无操作权限');
      }
    }),
    handlerSave: function handlerSave(formValue) {
      var _this5 = this;
      var _pram = this.buildFormPram(formValue);
      //大写转小写
      _pram.fields.map(function (item) {
        if (item.title === 'image_ext_str' || item.title === 'file_ext_str') item.value = item.value.toLowerCase();
        if (item.title === 'site_url') _this5.$store.commit('settings/SET_FrontDomain', item.value);
      });
      var _formId = 0;
      _pram.id = this.formConf.id;
      systemConfigApi.configSaveForm(_pram).then(function (data) {
        if (_pram.id === _settings.introSettingId) {
          _this5.$store.commit('settings/SET_IntroTypeList', []);
        }
        _this5.$message.success('添加数据成功');
      });
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this6 = this;
      var _pram = {
        type: this.$constants.categoryType[5].value,
        status: 1
      };
      this.loading = true;
      categoryApi.treeCategroy(_pram).then(function (data) {
        _this6.treeList = _this6.handleAddArrt(data);
        if (_this6.treeList.length > 0) _this6.activeNamel1 = _this6.treeList[0].id.toString();
        if (_this6.treeList.length > 0 && _this6.treeList[0].child) {
          _this6.activeNamel2 = _this6.treeList[0].child[0].extra;
        } else {
          _this6.getFromId();
        }
        _this6.handlerGetLevel2FormConfig(_this6.activeNamel2);
        _this6.loading = false;
      }).catch(function () {
        _this6.loading = false;
      });
    },
    handleAddArrt: function handleAddArrt(treeData) {
      // let _result = this.addTreeListLabel(treeData)
      var _result = selfUtil.addTreeListLabel(treeData);
      return _result;
    },
    buildFormPram: function buildFormPram(formValue) {
      var _pram = {
        fields: [],
        id: this.currentEditId,
        sort: 0,
        // 参数暂时无用
        status: true // 参数暂时无用
      };
      var _fields = [];
      Object.keys(formValue).forEach(function (key) {
        _fields.push({
          name: key,
          title: key,
          //提交数据要求是字符串，如果是数组，转为字符串
          value: formValue[key] instanceof Array ? formValue[key].join(',') : formValue[key]
        });
      });
      _pram.fields = _fields;
      return _pram;
    }
  }
};